<template>
  <div
    class="questionRender"

  >
    <div class="operation_title">
      <div class="tips">{{ questionType[question.questionTypeId] }}</div>
      <div
        class="zl_button zl_whiteButton"
        v-if="question.questionTypeId == 9 && show"
        @click.stop="handleGoStudy(question)"
      >
        去实操
      </div>
      <template>
        <span class="noshowbtn" v-if="isShowMore" @click.stop="isShowMore = false">收起</span>
        <span class="noshowbtn" v-else @click.stop="clickShowMore">展开</span>
      </template>
    </div>

    <!--    <template v-if="question.questionTypeId == 9 && show">-->
    <!--      <span class="btn" v-if="isShowMore" @click.stop="isShowMore = false">收起</span>-->
    <!--      <span class="btn" v-else @click.stop="clickShowMore">展开</span>-->
    <!--    </template>-->

    <div class="renderCont" v-loading="isLoading" :class="{ isShowMore: isShowMore }">
      <div
        class="editorShowArea ql-editor"
        style="height: calc(100% + 24px);"
        v-html="question.questionContent"
      ></div>

      <div v-if="question.questionTypeId < 9" style="padding: 10px 70px">
        <template v-if="content && content.length">
          <!-- 单选 -->
          <el-radio-group v-model="answer" v-if="question.questionTypeId == 1">
            <p v-for="(item, index) in content" style="padding: 5px 0;"
               :key="index">
              <el-radio
                :label="item.itemKey"
              >{{ item.itemKey + "、" + filterC(item.itemValue) }}
              </el-radio>
            </p>
          </el-radio-group>
          <!-- 多选 -->
          <el-checkbox-group
            v-model="answer"
            v-else-if="question.questionTypeId == 2"
          >
            <p v-for="(item, index) in content" style="padding: 5px 0;"
               :key="index">
              <el-checkbox
                :label="item.itemKey"
              >{{ item.itemKey + "、" + filterC(item.itemValue) }}
              </el-checkbox>
            </p>
          </el-checkbox-group>

        </template>
        <template>
          <!-- 判断题 -->
          <el-radio-group v-model="answer" v-if="question.questionTypeId == 3">
            <p style="padding: 5px 0;">
              <el-radio label="正确">
                <i class="el-icon-check"></i>
              </el-radio>
            </p>
            <p style="padding: 5px 0;">
              <el-radio label="错误">
                <i class="el-icon-close"></i>
              </el-radio>
            </p>
          </el-radio-group>
        </template>
           
      </div>

      <!-- 保存btn -->
      <div class="answer_sec" v-if="show && question.questionTypeId < 9">
        <!-- 正确答案 -->
        <div v-if="isShowAnswer" class="official_answer">
          <p>
            <strong>作答结果：</strong>
            <span v-if="answer_res" style="color: #67C23A;">正确</span>
            <span v-else style="color: #F56C6C;">错误</span>
          </p>
<!--          <p><strong>正确答案：</strong>{{ official_answer }}</p>-->
          <p v-if="!answer_res && questionAnalysis" v-html="questionAnalysis"></p>
        </div>
        <span class="zl_button zl_blueButton" @click="saveAnswer(question)">保存答案</span>
      </div>

    </div>
  </div>
</template>

<script>
  import * as newCourseApi from "../../api/newCourseApi";
  import * as api from "../../api/courseApi";

  export default {
    name: "questionRender.vue",
    props: {
      question: {
        type: Object,
        default: () => {
        },
      },
      questionAnswer: {
        type: Object,
        default: () => {
        },
      },
      isShow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        show: this.isShow,
        courseId: this.$route.query.courseId,
        classId: this.$route.query.classId,
        currentValue: {},
        isLoading: false,
        isShowMore: false,
        answer: null,
        answer_res: null,
        official_answer: null,
        isShowAnswer: false,
        content: [], // 选项
        questionAnalysis: '', // 解析
        questionType: {
          1: "单选题",
          2: "多选题",
          3: "判断题",
          4: "填空题",
          5: "问答题",
          9: "实操题",
        },
      };
    },
    watch: {
      question: {
        handler(newVal, oldVal) {
          if (newVal && oldVal && newVal.value != oldVal.value) {
            this.isShowMore = false;
            this.isShowAnswer = false;
            this.answer_res = false;
          }
        },
        immediate: true,
        deep: true,
      },
      questionAnswer: {
        handler(val) {
          if (!val) return;
          this.setAnswer(val);
        },
        immediate: true,
        deep: true,
      },
    },
    created() {
      if (this.question.questionTypeId == 2) {
        this.answer = [];
      } else {
        this.answer = "";
      }
    },
    methods: {
      clickShowMore() {
        if (this.show) this.QueryAnswer(this.question.value);
        this.isShowMore = true;
        this.content = [];
        if (this.question.questionTypeId < 9) {
          this.isLoading = true;
          newCourseApi
            .QueryQuestionById(this.question.value)
            .then((res) => {
              if (res.code == 0) {
                if (res.data) {
                  this.content = res.data.items;
                  this.questionAnalysis = res.data.questionAnalysis;
                } else {
                  this.content = [];
                  this.$messageError('该试题不存在')
                }

              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      },

      filterC(str) {
        let reg = /<\/?.+?\/?>/g;
        return str.replace(reg, "");
      },
      handleGoStudy(item) {
        if (!this.question.value) return this.$message.warning('试题数据不完整，请重新添加试题');
        this.isLoading = true;
        //试题详情
        api
          .getAnswer(this.question.value)
          .then((res) => {
            if (res.code === "0") {
              if (res.data && res.data.event && res.data.event.length) {
                let arr = res.data.event.filter((val) => {
                  return val && val.questionId == item.value;
                });
                if (arr.length) this.$emit("handleGoStudy", item, arr[0]);
              }
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
        // this.saveAnswer(this.question, 9);
      },
      saveAnswer(item, type) {
        let userAnswer = '';
        if (type === 9) {
          userAnswer = '实操题，暂时点击既完成'
        } else {
          userAnswer = item.questionTypeId == 2 ? this.answer.join(',') : this.answer;
        }
        // 保存作答记录
        let param = {
          "courseId": this.courseId,
          "classId": this.classId,
          "questionId": item.value,
          "questionType": item.questionTypeId, //** 试题类型 1:单选题,2:多选题,3:判断题,4:问答题,6:组合题,9:实操题 */
          "version": new Date().getTime(),
          "userAnswer": userAnswer,
          "useTime": 0,
          "questionStatus": 0,
          "stepId": 0,
          "resourceId": item.value
        }
        api.SaveRecord(param).then(res => {
          if (res.code == 0) {

            this.QueryAnswer(item.value);
            // this.$emit('getQuestionAnswer', item.value)
          } else {
            this.$message.warning(res.msg);
          }
        })
      },
      QueryAnswer(questionId) {
        api.QueryAnswer({
          courseId: this.courseId,
          classId: this.classId,
          questionIds: [questionId]
        }).then(res => {
          if (res.code == 0) {
            if (res.data[0]){
              this.setAnswer(res.data[0]);
            }
          }
        })
      },
      setAnswer(val) {
        if (!val.userAnswer) return;
        this.answer = val.questionType == 2 ? val.userAnswer.split(",") : val.userAnswer;
        this.isShowAnswer = val.userAnswer != null ? true : false;
        this.official_answer = val.answer;
        if (val.questionType == 2) {
          let str = val.userAnswer.split(",").sort().join();
          this.answer_res = val.answer == str ? true : false;
        } else {
          this.answer_res = val.answer == val.userAnswer ? true : false;
        }
      }
    },
  };
</script>

<style scoped lang="scss">
  .questionRender {
    width: 100%;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(0, 124, 237, 0.06);
    border-radius: 4px;

    .operation_title {
      height: 45px;
      line-height: 45px;
      padding-right: 10px;
      box-sizing: border-box;
      // border-bottom: 2px solid #ffffff;
      text-align: right;
      position: relative;

      .tips {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: #FFCB00;
        border-radius: 4px 0px 10px 0px;
        font-size: 13px;
        font-weight: 500;
        color: #0F0D11;
        text-align: center;
      }
    }

    .renderCont {
      height: 60px;
      min-height: 60px;
      overflow: hidden;
    }

    .isShowMore {
      height: auto;
    }

    .noshowbtn {
      font-size: 13px;
      color: #007fff;
      cursor: pointer;
      margin-left: 20px;
    }

    .editorShowArea {
      /deep/ img {
        max-width: 98%;
      }
    }

    .answer_sec {
      padding: 0px 70px 10px;

      .official_answer {
        margin-bottom: 10px;
        color: #409EFF;

        p {
          margin-bottom: 10px;
        }

        strong {
          font-size: 12px;
          color: #262628;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/component/questionRender.vue